import { __module as e } from "../../../../../_virtual/compiler-runtime2.js";
import { __require as i } from "./cjs/react-compiler-runtime.production.js";
import { __require as o } from "./cjs/react-compiler-runtime.development.js";
var r;
function p() {
  return r ? e.exports : (r = 1, process.env.NODE_ENV === "production" ? e.exports = i() : e.exports = o(), e.exports);
}
export {
  p as __require
};
